/* eslint-disable max-lines */
import { css } from 'linaria';

export const horizontalMediaCard = css`
  && {
    display: flex;
    flex-direction: row;
    height: 590px;

    @media (--only-desktop) {
      height: 470px;
    }

    @media (--to-desktop) {
      display: flex;
      flex-direction: column;
      height: 100%;
      box-shadow: none;
    }
  }
`;

export const reverseMedia = css`
  && {
    @media (--from-desktop) {
      order: 2;
      border-radius: 0 var(--rounding-l) var(--rounding-l) 0;
    }
  }
`;

export const horizontalMedia = css`
  width: 50%;
  height: 100%;
  border-radius: var(--rounding-l) 0 0 var(--rounding-l);

  @media (--to-desktop) {
    width: 100%;
    margin-bottom: 24px;
    border-radius: var(--rounding-m);
  }

  @media (--only-tablet) {
    height: 603px;
  }

  @media (--only-mobile) {
    height: auto;
  }
`;

export const cardContent = css`
  position: relative;
  width: 50%;
  padding: 48px 40px;

  @media (--only-desktop) {
    padding: 24px 32px;
  }

  @media (--only-tablet) {
    min-height: 495px;
  }

  @media (--only-mobile) {
    min-height: 461px;
  }

  @media (--to-desktop) {
    width: 100%;
    padding: 0;
  }
`;

export const centerCardContent = css`
  @media (--only-mobile) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const solutionSize = css`
  margin-bottom: 33px;

  @media (--only-desktop) {
    margin-bottom: 17px;
  }

  @media (--only-mobile) {
    margin-bottom: 17px;
  }
`;

export const solutionTitle = css`
  && {
    margin-bottom: 8px;

    @media (--only-desktop) {
      margin-bottom: 2px;
    }

    @media (--only-mobile) {
      font-size: 22px;
      line-height: 28px;
    }
  }
`;

export const centerCard = css`
  align-items: center;

  @media (--to-desktop) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const productImage = css`
  margin-bottom: 16px;
  object-fit: contain;

  @media (--only-desktop) {
    width: 100px;
    height: 106px;
    margin-bottom: 2px;
  }

  @media (--only-tablet) {
    width: 108px;
    height: 115px;
    margin-bottom: 18px;
  }

  @media (--only-mobile) {
    width: 100px;
    height: 106px;
    margin-bottom: 2px;
  }
`;

export const productCount = css`
  width: max-content;
  padding: 0 6px;
  margin-bottom: 17px;
  background-color: var(--background-secondary);
  border-radius: 100px;

  @media (--only-desktop) {
    margin-bottom: 8px;
  }

  @media (--only-mobile) {
    margin-bottom: 8px;
  }
`;

export const productName = css`
  display: -webkit-box;
  margin-bottom: 16px;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;

  @media (--only-desktop) {
    margin-bottom: 8px;
    -webkit-line-clamp: 4;
  }

  @media (--only-mobile) {
    margin-bottom: 8px;
    -webkit-line-clamp: 4;
  }
`;

export const productPrice = css`
  && {
    margin-bottom: 13px;
    line-height: 28px;

    @media (--only-desktop) {
      margin-bottom: 7px;
    }

    @media (--only-mobile) {
      margin-bottom: 8px;
      font-size: 20px;
      line-height: 28px;
    }
  }
`;

export const productPriceCurrency = css`
  && {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const swiper = css`
  && {
    width: 482px;

    @media (--only-desktop) {
      width: 392px;
    }

    @media (--only-tablet) {
      width: 648px;
      padding-right: 0;
      padding-left: 0;
      margin-right: auto;
      margin-left: auto;
    }

    @media (--only-mobile) {
      width: auto;
      padding-right: 16px;
      padding-left: 16px;
      margin-right: -16px;
      margin-left: -16px;
    }

    .swiper-button-prev.swiper-button-prev {
      top: 47%;
      left: 10px;
      width: 40px;
      height: 40px;
      color: transparent;

      &::after {
        width: 20px;
        height: 20px;
      }

      @media (--only-desktop) {
        top: 49%;
        left: 4px;
        width: 32px;
        height: 32px;

        &::after {
          width: 16px;
          height: 16px;
        }
      }

      @media (--only-tablet) {
        top: 46%;
        left: -36px;
        display: flex;
        width: 40px;
        height: 40px;
      }
    }

    .swiper-button-next.swiper-button-next {
      top: 47%;
      right: 32px;
      width: 40px;
      height: 40px;
      color: transparent;

      &::after {
        width: 20px;
        height: 20px;
      }

      @media (--only-desktop) {
        top: 49%;
        right: 25px;
        width: 32px;
        height: 32px;

        &::after {
          width: 16px;
          height: 16px;
        }
      }

      @media (--only-tablet) {
        top: 46%;
        right: -22px;
        display: flex;
        width: 40px;
        height: 40px;
      }
    }
  }
`;

export const swiperSlideStyle = css`
  && {
    width: 150px;
    margin-right: 16px;

    &:last-of-type {
      margin-right: 0;
    }

    @media (--only-desktop) {
      width: 120px;
    }

    @media (--only-mobile) {
      width: 120px;
    }
  }
`;

export const loaderWrapper = css`
  display: flex;
  justify-content: center;
`;

export const cardBottom = css`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-top: 32px;

  @media (--to-desktop) {
    margin-top: 16px;
  }

  @media (--only-mobile) {
    flex-direction: column;
    align-items: baseline;
  }
`;

export const productTotalCount = css`
  && {
    margin-bottom: 7px;
    color: var(--text-secondary);

    @media (--only-desktop) {
      margin-bottom: 2px;
    }

    @media (--only-tablet) {
      margin-bottom: 8px;
    }

    @media (--only-mobile) {
      margin-bottom: 2px;
      font-size: 16px;
      line-height: 24px;
    }
  }
`;

export const productTotalPrice = css`
  && {
    @media (--only-mobile) {
      margin-bottom: 16px;
      font-weight: 500;
      font-size: 26px;
      line-height: 32px;
    }
  }
`;

export const productTotalPriceCurrency = css`
  && {
    font-weight: 500;
    font-size: 20px;
    line-height: 26px;

    @media (--only-mobile) {
      font-size: 26px;
      line-height: 32px;
    }
  }
`;

export const basketButton = css`
  && {
    @media (--only-mobile) {
      width: 188px;
      font-size: 16px;
      line-height: 16px;
    }
  }
`;
